<h2 mat-dialog-title>Verknüpfte Stillstände</h2>
<mat-dialog-content>
  <div *ngIf="data.reports && data.reports.length > 0; else noReports">
    <table mat-table [dataSource]="data.reports" class="w-full">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td
          mat-cell
          *matCellDef="let report"
          class="cursor-pointer text-decoration-underline report-link"
          [routerLink]="['/report', report.id]">
          {{ report.incident_id }}
        </td>
      </ng-container>

      <!--<ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>StillstandsId</th>
        <td mat-cell *matCellDef="let report">{{ report.incident_id }}</td>
      </ng-container>-->

      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Datum</th>
        <td mat-cell *matCellDef="let report">{{ report.created_at | date:'dd.MM.yyyy HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let report">
          <mat-icon class="cursor-pointer" (click)="deleteReport(report.id)">delete</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <ng-template #noReports>
    <p>Keine verknüpften Stillstände gefunden.</p>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Schließen</button>
</mat-dialog-actions>
